import React from 'react';

const IconLoader = () => (
  <svg id="nameplate" version="1.0" xmlns="http://www.w3.org/2000/svg" width="700.000000pt" height="143.000000pt" viewBox="0 0 700.000000 143.000000" preserveAspectRatio="xMidYMid meet">
<g transform="translate(0.000000,143.000000) scale(0.100000,-0.100000)" fill="none" stroke="#F1529B" stroke-width="25">
<path d="M1185 1203 c-250 -168 -728 -474 -733 -469 -4 4 230 359 296 450 28
37 33 52 25 65 -6 9 -15 16 -21 16 -6 0 -79 -101 -163 -225 -240 -356 -393
-607 -496 -815 -73 -145 -80 -171 -57 -196 24 -26 46 -24 43 4 -6 49 52 173
198 422 62 105 94 151 108 152 21 3 69 -31 271 -197 170 -139 219 -174 238
-167 28 11 17 31 -37 68 -29 20 -113 88 -187 149 -74 62 -159 129 -188 148
-29 19 -51 40 -49 46 2 6 33 29 68 51 107 66 493 315 674 433 93 62 177 112
185 112 24 0 74 56 67 74 -4 9 -14 16 -24 15 -10 -1 -108 -62 -218 -136z"></path>
<path d="M2463 1148 c-45 -47 -168 -239 -219 -340 -39 -79 -51 -92 -126 -151
-120 -94 -282 -176 -304 -154 -11 11 34 142 64 186 16 23 43 51 61 62 27 16
31 22 21 34 -20 24 -36 18 -107 -43 -118 -101 -207 -166 -270 -196 -74 -35
-98 -31 -88 16 10 43 38 98 70 136 28 33 26 52 -5 52 -10 0 -73 -52 -140 -115
-135 -127 -157 -144 -166 -121 -7 19 23 75 85 160 27 38 48 73 45 78 -12 19
-40 5 -97 -49 -79 -72 -128 -108 -199 -144 -63 -32 -106 -37 -115 -14 -9 24
26 104 63 145 19 21 34 45 34 54 0 27 -29 31 -54 7 -20 -19 -23 -19 -38 -5
-40 40 -195 -60 -248 -159 -26 -50 -22 -90 11 -108 32 -17 66 -3 124 51 28 28
54 50 56 50 2 0 5 -12 6 -27 2 -35 36 -63 77 -63 34 0 106 31 175 75 34 21 42
23 37 10 -27 -71 -13 -105 42 -105 41 0 64 13 132 74 l45 41 3 -32 c4 -38 42
-73 79 -73 13 0 47 10 74 22 l50 21 47 -46 c48 -48 94 -62 105 -34 3 8 31 19
63 25 59 12 153 59 237 119 46 32 48 33 42 11 -4 -13 -13 -34 -20 -48 -7 -14
-16 -40 -20 -58 -5 -25 -3 -33 11 -39 18 -7 21 -3 182 176 41 44 78 81 83 81
5 0 -9 -36 -31 -81 -48 -94 -49 -129 -7 -144 24 -8 39 -4 95 25 36 19 69 37
74 38 4 2 8 -7 8 -21 0 -13 8 -31 18 -40 36 -32 70 -19 150 57 42 40 42 40 42
14 0 -34 42 -68 84 -68 36 0 100 28 169 72 26 17 49 29 52 27 2 -2 -1 -25 -7
-51 -9 -36 -8 -51 2 -63 16 -19 60 -19 105 -1 74 31 340 227 340 250 0 29 -41
12 -110 -46 -90 -76 -250 -178 -278 -178 -17 0 -19 5 -14 35 12 75 49 130 146
215 132 118 284 311 298 380 6 34 -11 46 -53 36 -62 -16 -242 -231 -354 -422
-42 -72 -105 -127 -205 -180 -71 -36 -112 -43 -121 -19 -10 24 22 102 62 150
35 44 40 75 11 75 -8 0 -22 -9 -32 -20 -17 -19 -20 -19 -36 -4 -16 15 -22 15
-67 0 -27 -9 -74 -39 -108 -67 -70 -60 -236 -161 -247 -150 -4 4 10 45 32 92
51 108 58 137 37 145 -33 13 -71 -9 -147 -84 -44 -43 -79 -74 -79 -70 0 12
104 212 158 304 58 100 148 221 173 235 28 14 23 29 -9 29 -19 0 -38 -11 -59
-32z m987 -45 c0 -21 -220 -287 -246 -297 -20 -8 -6 17 58 101 99 131 188 225
188 196z m-2480 -389 c0 -10 -144 -165 -173 -186 -63 -45 -45 25 26 99 28 30
68 63 87 74 35 18 60 24 60 13z m1800 -1 c0 -13 -186 -203 -199 -203 -25 0 -9
49 31 95 68 77 168 141 168 108z m-995 -144 c-19 -70 -27 -76 -65 -49 -17 12
-28 26 -23 31 15 15 88 68 95 68 3 1 0 -22 -7 -50z"></path>
<path d="M4663 1385 c-139 -25 -305 -85 -468 -166 -155 -77 -351 -204 -347
-224 1 -5 17 -14 34 -18 128 -33 181 -290 98 -473 -11 -22 -29 -65 -40 -95
-12 -30 -48 -111 -82 -181 -33 -70 -58 -135 -56 -145 5 -28 48 -30 55 -3 13
47 85 183 168 316 123 194 135 209 192 224 178 48 516 188 658 272 82 49 224
185 254 245 53 106 33 178 -64 228 -56 29 -65 30 -194 32 -80 1 -166 -4 -208
-12z m319 -26 c68 -15 118 -62 118 -110 0 -87 -103 -219 -239 -308 -44 -29
-143 -82 -222 -117 -146 -67 -429 -169 -429 -155 0 4 61 90 135 192 74 101
134 191 132 199 -1 8 -10 16 -19 18 -20 4 -61 -51 -391 -518 l-17 -25 7 40 c5
22 8 83 8 135 -1 127 -22 188 -87 252 l-49 48 93 61 c319 210 738 335 960 288z"></path>
<path d="M6728 1170 c-36 -22 -188 -252 -264 -403 -30 -58 -155 -155 -281
-218 -106 -52 -154 -60 -177 -28 -9 13 -16 27 -16 31 0 4 26 21 59 37 77 39
131 91 131 124 0 51 -72 63 -133 22 -20 -14 -37 -22 -37 -17 0 12 119 188 175
262 24 30 68 82 99 115 60 64 66 75 38 75 -39 0 -237 -230 -319 -371 -43 -74
-51 -82 -149 -145 -106 -67 -198 -116 -266 -140 -33 -11 -38 -11 -38 2 0 29
53 118 101 169 27 29 49 57 49 63 0 21 -21 24 -41 6 -19 -18 -21 -18 -30 -1
-20 34 -106 15 -209 -48 -32 -19 -61 -35 -64 -35 -4 0 0 13 8 29 9 16 12 31 9
35 -15 15 -38 2 -111 -60 -129 -110 -262 -172 -278 -130 -11 29 14 91 57 146
38 48 40 53 25 68 -15 15 -18 15 -38 -5 -19 -19 -23 -20 -43 -7 -66 43 -265
-121 -265 -219 0 -13 8 -31 18 -40 36 -32 70 -19 150 57 42 40 42 40 42 14 0
-34 42 -68 86 -68 33 0 126 43 199 93 21 14 41 24 43 22 3 -3 -12 -30 -32 -61
-35 -53 -37 -58 -21 -73 16 -15 18 -14 33 9 8 14 48 57 87 95 79 78 211 155
264 155 37 0 38 -6 7 -39 -14 -15 -41 -53 -60 -85 -104 -172 31 -180 294 -18
36 22 66 39 68 37 2 -2 -15 -40 -38 -84 -22 -45 -38 -86 -35 -91 13 -21 43 -9
55 20 15 37 48 80 61 80 5 0 9 -8 9 -18 0 -10 12 -29 26 -43 53 -49 177 -18
339 85 31 21 60 35 63 32 3 -4 -5 -26 -17 -51 -30 -60 -32 -99 -6 -103 15 -2
42 24 104 98 84 101 149 165 158 157 2 -3 -12 -37 -31 -76 -50 -97 -46 -151 9
-151 41 0 375 216 375 243 0 28 -41 10 -142 -62 -128 -91 -224 -146 -232 -132
-3 5 14 49 39 97 61 121 60 153 -8 139 -22 -5 -57 -33 -110 -87 -52 -52 -76
-71 -72 -56 4 13 46 95 95 184 97 178 209 339 241 347 12 3 18 10 14 16 -8 13
-44 14 -67 1z m-598 -454 c0 -26 -122 -117 -137 -102 -3 3 20 30 50 60 54 55
87 70 87 42z m-1152 -6 c-5 -15 -188 -200 -199 -200 -5 0 -9 11 -9 24 0 33 72
121 128 157 45 28 87 39 80 19z"></path>
<path d="M5725 856 c-24 -20 -28 -27 -17 -37 10 -11 19 -10 47 5 37 20 45 40
19 50 -9 3 -16 6 -17 6 -1 0 -15 -11 -32 -24z"></path>
</g>
</svg>
);

export default IconLoader;
